
export function handleResponse (response, successCallback, errorCallback) {
  var code = response.data.code

  if (code === 1000) {
    successCallback(response.data.data)
  } else {

    // console.log("code------" + code)
    if (code === 401){

      // this.$router.push('/login')
      // window.location.href = '/login'
    }else {

    }
    // this.$message(
    //   {
    //     showClose:true,
    //     message: '服务器异常',
    //     type: 'error'
    //   }
    // )
    // var error = ''
    errorCallback("")
  }
}
